/* Warehouse conserva el formulario, los identificadores y su propio sticky/OverflowScroller.
 * Se mueve la única descripción existente, sin copiarla ni tocar precio/SKU/variantes.
 */
(function () {
  'use strict';
  var controllers = new WeakMap();

  function initialize(section) {
    if (controllers.has(section) || !section.querySelector('.arol-confidence--product')) return;
    var wrapper = section.querySelector('.product-block-list__wrapper');
    var info = wrapper && wrapper.querySelector('.product-block-list__item--info');
    if (!wrapper || !info) return; // No intervenir vistas rápidas ni otros componentes.
    var confidence = info.querySelector('.arol-confidence--product');
    var facts = confidence.querySelector('.arol-confidence__facts');
    var details = facts ? Array.from(facts.children).filter(function (node) { return node.tagName === 'DETAILS'; }) : [];
    if (details.length !== 3 || !window.HTMLDialogElement) return;
    var description = section.querySelector('.product-block-list__item--description');
    var consultation = info.querySelector('[data-arol-consultation]');
    var seller = confidence.querySelector('.arol-confidence__seller');
    var quoteAction = confidence.querySelector('.arol-confidence__quote-action');
    var home = null, dataHome = null, quoteHome = null, dataBlock = null, sellerLine = null, nav = null, dialog = null;
    var media = window.matchMedia('(min-width: 1000px)');

    function dismiss() { if (dialog && dialog.open) dialog.close(); }

    function show(index, trigger) {
      if (!media.matches) return;
      dismiss();
      var detail = details[index], summary = detail.querySelector('summary');
      var body = detail.querySelector('.arol-confidence__body');
      if (!body || !summary) return;
      var current = document.createElement('dialog');
      current.className = 'arol-product-confidence-dialog';
      current.setAttribute('aria-label', summary.querySelector('strong').textContent);
      var header = document.createElement('div');
      header.className = 'arol-product-confidence-dialog__header';
      var headingGroup = document.createElement('div');
      var heading = document.createElement('h2');
      heading.textContent = summary.querySelector('strong').textContent;
      headingGroup.appendChild(heading);
      var small = summary.querySelector('small');
      if (small) headingGroup.appendChild(small.cloneNode(true));
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'arol-product-confidence-dialog__close';
      close.setAttribute('aria-label', 'Cerrar');
      close.textContent = '×';
      close.addEventListener('click', function () { current.close(); });
      header.appendChild(headingGroup);
      header.appendChild(close);
      current.appendChild(header);
      // Copia literal del contenido actual del bloque; no genera texto alternativo.
      current.appendChild(body.cloneNode(true));
      current.addEventListener('close', function () {
        current.remove();
        if (dialog === current) dialog = null;
        if (trigger.isConnected && media.matches) trigger.focus();
      }, { once: true });
      current.addEventListener('click', function (event) {
        if (event.target !== current) return;
        var rect = current.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) current.close();
      });
      document.body.appendChild(current);
      dialog = current;
      current.showModal();
    }

    function enable() {
      if (nav) return;
      if (description) {
        home = document.createComment('AROL: ubicación original de descripción para móvil');
        description.before(home);
        info.after(description); // Estructura de Warehouse: galería, info, descripción en el wrapper.
      }
      if (consultation) {
        dataHome = document.createComment('AROL: ubicación original de datos para móvil');
        consultation.before(dataHome);
        dataBlock = document.createElement('div');
        dataBlock.className = 'product-block-list__item product-block-list__item--arol-data';
        dataBlock.appendChild(consultation); // El mismo nodo y la misma lógica de datos existente.
        var leftAnchor = description || wrapper.querySelector('.product-block-list__item--gallery');
        if (leftAnchor) leftAnchor.after(dataBlock);
        else wrapper.appendChild(dataBlock);
      }
      if (seller) {
        sellerLine = document.createElement('a');
        sellerLine.className = 'arol-product-seller-line';
        sellerLine.href = seller.getAttribute('href');
        sellerLine.textContent = 'Vendido por Electrodomésticos Olvera · desde 1997 · ver sucursales';
        seller.after(sellerLine);
      }
      nav = document.createElement('nav');
      nav.className = 'arol-product-confidence-links';
      nav.setAttribute('aria-label', 'Información para tu compra');
      ['Preparación', 'Envío', 'Devoluciones'].forEach(function (label, index) {
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.setAttribute('aria-haspopup', 'dialog');
        var icon = details[index].querySelector('.arol-confidence__icon svg');
        if (icon) trigger.appendChild(icon.cloneNode(true));
        trigger.appendChild(document.createTextNode(label));
        trigger.addEventListener('click', function () { show(index, trigger); });
        nav.appendChild(trigger);
      });
      facts.before(nav);
      if (quoteAction) {
        quoteHome = document.createComment('AROL: ubicación original de cotización para móvil');
        quoteAction.before(quoteHome);
        nav.after(quoteAction);
      }
      section.setAttribute('data-arol-desktop-ready', '');
    }

    function disable() {
      dismiss();
      section.removeAttribute('data-arol-desktop-ready');
      if (quoteHome) { quoteHome.replaceWith(quoteAction); quoteHome = null; }
      if (nav) { nav.remove(); nav = null; }
      if (dataHome) { dataHome.replaceWith(consultation); dataHome = null; }
      if (dataBlock) { dataBlock.remove(); dataBlock = null; }
      if (sellerLine) { sellerLine.remove(); sellerLine = null; }
      if (home) { home.replaceWith(description); home = null; }
    }
    function refresh() { if (media.matches) enable(); else disable(); }
    refresh();
    media.addEventListener('change', refresh);
    controllers.set(section, function () { disable(); media.removeEventListener('change', refresh); });
  }

  function start(root) {
    if (root.matches && root.matches('[data-section-type="product"]')) initialize(root);
    root.querySelectorAll('[data-section-type="product"]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var destroy = controllers.get(event.target);
    if (destroy) destroy();
  });
})();
